import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class LandscapeRatingComponent extends Component {
  static readonly TYPE_ID: string = 'd05867279e524949ab793ac20ae02634';

  constructor(
    public readonly landscapeRating: number,
  ) {
    super();
  }

  get $typeId() {
    return LandscapeRatingComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LandscapeRatingComponent {
    return new LandscapeRatingComponent(
        MapUtils.get<number>(map, 'landscapeRating'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'landscapeRating': this.landscapeRating,
    };
  }

  clone(): this {
    return new LandscapeRatingComponent(
        this.landscapeRating,
    ) as this;
  }

  isSame(other: LandscapeRatingComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.landscapeRating === this.landscapeRating;
  }
}

export class LandscapeRatingComponentBuilder extends DataModelBuilder<LandscapeRatingComponent> {
  build(context: SerializationContext, map: SerializedData): LandscapeRatingComponent {
    return LandscapeRatingComponent.fromMap(context, map);
  }
}
